<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-col cols="10" class="text-right">
         <v-btn color="yellow-light" @click="exportData()">
              <v-icon left>mdi-download</v-icon>
              Export Data
            </v-btn>
        </v-col>
            </v-row>
            <br>

         <!-- icon data -->
            <v-card elevation="7">
              <v-card-text>
                <div class="text-center">
                  <v-row class="mb-6" justify="center" no-gutters>
                      <v-col cols="3">
                      <v-icon color="deep-purple darken-2" size="50" @click="saerchDataAdvanced()"
                        >mdi-account-search </v-icon
                      ><br />
                      ทั้งหมด
                      <br />
                      <v-alert dark dense border="left" color="deep-purple darken-2">
                        จำนวน : {{ number1 }}
                      </v-alert>
                    </v-col>
                    <v-col cols="1">
                      <v-divider vertical></v-divider>
                    </v-col>
                    <v-col cols="3">
                      <v-icon color="green darken-2" size="50" @click="getDataEmpUpdate()"
                        >mdi-account-check</v-icon
                      ><br />
                      แก้ไขข้อมูลแล้ว
                      <br />
                      <v-alert dense border="left" color="green darken-2" class="text-white">
                        จำนวน : {{ number3 }}
                      </v-alert>
                    </v-col>
                    <v-col cols="1">
                      <v-divider vertical></v-divider>
                    </v-col>
                    <v-col cols="3">
                      <v-icon color="deep-orange" size="50" @click="getDataEmpNotUpdate()"
                        >mdi-account-cancel</v-icon
                      ><br />
                      ยังไม่ได้แก้ไขข้อมูล
                      <br />
                      <v-alert dense border="left" color="deep-orange" class="text-white">
                        จำนวน : {{ number2 }}
                      </v-alert>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
             <!-- END icon data -->

          <!-- data table -->
          <v-row>
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
                <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                   <template v-slot:[`item.LAST_DATE`]="{ item }">
                      {{ format_date(item.LAST_DATE) }}
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>

      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import Index from '../../UploadExcel/index.vue'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    Index
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      path: '/system_user/', // Path Model
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      session: this.$session.getAll(),
      // Search All
      search: null,
      searchAll: '',
      searchAll2: '',
      number1: 0,
      number2: 0,
      number3: 0,
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'ข้อมูลพนักงาน',
          disabled: true,
          href: '/HRM/Employee/EmployeeCheckList'
        }
      ],
      // End Menu Config
      // Data Table Config
      columns: [
        { text: 'รหัสพนักงาน', value: 'empCode', align: 'center' },
        { text: 'ชื่อ-นามสกุล', value: 'empFull_NameTH', align: 'center' },
        { text: 'สถานะการแก้ไขข้อมูล', value: 'updateStatus', align: 'center' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'วันที่แก้ไขข้อมูล', value: 'LAST_DATE' },
        { text: 'LAST_USER', value: 'LAST_USER' }
      ],
      dataItem: [],
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ]
    }
  },
  async mounted () {
    this.getGetToken(this.DNS_IP)
    this.dataReady = false
    // Get Data
    await this.getDataGlobal(this.DNS_IP, this.path)
    await this.getDataCount()
    await this.saerchDataAdvanced()
  },
  methods: {
    async saerchDataAdvanced () {
      var search =
        '?userCode=' + this.searchAll + '&userName=' + this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(this.DNS_IP, this.path, search)
    },
    async getDataEmpNotUpdate () {
      this.dataReady = false
      this.dataItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/system_user/' + "get?updateStatus=ยังไม่ได้แก้ไขข้อมูล",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
        })
    },
    async getDataEmpUpdate () {
      this.dataReady = false
      this.dataItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/system_user/' + "get?updateStatus=แก้ไขข้อมูลแล้ว",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
        })
    },
    async getDataCount () {
      this.number1 = 0
      this.number2 = 0
      this.number3 = 0
      let rs = this.dataItem
      this.number1 = rs.length
      for (var i = 0; i < rs.length; i++) {
        var d = rs[i]
        if (d.updateStatus === 'ยังไม่ได้แก้ไขข้อมูล') {
          this.number2 = this.number2 + 1
        }
        if (d.updateStatus === 'แก้ไขข้อมูลแล้ว') {
          this.number3 = this.number3 + 1
        }
      }
    },
    exportData () {
      this.dataItem = []
      axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/system_user/' + "get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataItem = response.data
          var tem = []
          response.data.forEach(element => {
            var s = {}
            console.log(element)
            s.empCode = element.empCode
            s.empFull_NameTH = element.empFull_NameTH
            s.masBranchName = element.masBranchName
            s.masDepartmentName = element.masDepartmentName
            s.updateStatus = element.updateStatus
            s.LAST_DATE = element.LAST_DATE
            tem.push(s)
          })
          console.log(tem)
          var info = XLSX.utils.json_to_sheet(tem)
          var wb = XLSX.utils.book_new() // make Workbook of Excel
          XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
          XLSX.writeFile(wb, 'รายชื่อพนักงานอัพเดทข้อมูล.xls') // name of the file is 'book.xlsx'
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>
<style scope>
</style>



// WEBPACK FOOTER //
// src/components/HRM/Employee/EmployeeCheckList.vue